<template>
  <model-form
    ref="modelForm"
    :model="newsItemClass"
    modal-type="modal"
  >
    <div class="q-gutter-sm">
      <div class="row q-col-gutter-md items-start">
        <q-input
          v-model="newsItemClass.name"
          class="col-12"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
          :autofocus="!$q.platform.is.ios"
        />
      </div>
    </div>
  </model-form>
</template>

<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'NewsItemClassForm',
  components: {
    ModelForm
  },
  models: {
    newsItemClass: 'default'
  },
  methods: {
    show (model, initialData) {
      this.$refs.modelForm.show(model, initialData)
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
